import { createAsyncThunk } from "@reduxjs/toolkit";
import { menuCategoriesService } from "service/menuCategoriesService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getAllMenuCategories = createAsyncThunk(
  "menuCategories/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await menuCategoriesService.getAllMenuCategories();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getMenuCategoryById = createAsyncThunk(
  "menuCategories/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await menuCategoriesService.getMenuCategoryById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createMenuCategory = createAsyncThunk(
  "menuCategories/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await menuCategoriesService.createMenuCategory(data);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateMenuCategory = createAsyncThunk(
  "menuCategories/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await menuCategoriesService.updateMenuCategory(id, data);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteMenuCategory = createAsyncThunk(
  "menuCategories/delete",
  async (id, { rejectWithValue }) => {
    try {
      await menuCategoriesService.deleteMenuCategory(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      return id;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const reorderMenuCategories = createAsyncThunk(
  "menuCategories/reorder",
  async (categoryIds, { rejectWithValue }) => {
    try {
      const response = await menuCategoriesService.reorderMenuCategories(categoryIds);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
